export default __webpack_public_path__ + "static/media/image.226bbdf0.png";